import React from "react";
//@ts-ignore
import IntlMessages from "@util/IntlMessages";

import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";
import NewsletterGraphSettings from "./NewsletterGraphSettings";

const NewsletterGraphModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.viewSettings" />} key="2">
            <NewsletterGraphSettings {...props} value={props.value} />
         </TabPane>
      </Tabs>
   );
};

export default NewsletterGraphModal;
